import React, { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, IconButton, Typography, Paper, TableContainer } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import PaymentChallanPopup from ".";
import DialogContentModal from "../../../../../../templates/ApplicationDetails/components/DialogContent";
import PaymentPrint from "../../PaymentSlipEmp/PaymentSlip";

const ViewCompletionChallan = ({ formData, taxHead, totalAmount }) => {
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [selectedChallanNo, setSelectedChallanNo] = useState("");
  const [taxHeadEstimates, setTaxHeadEstimates] = useState(formData?.taxHeadEstimates || []);

  // Delete handler
  const handleDelete = async (applicationNumber, challanNo, index, estimateAmount) => {
    try {
      await Digit.OBPSService.deleteChallan({}, { applicationNumber, challanNo, estimateAmount });
      // Remove the deleted item from the table
      const updated = [...taxHeadEstimates];
      updated.splice(index, 1);
      setTaxHeadEstimates(updated);
    } catch (e) {
      // Optionally handle error
      alert("Failed to delete challan.");
    }
  };

  return (
    <TableContainer component={Paper} sx={{ width: "100%", overflowX: "auto" }}>
      <Table sx={{ minWidth: 700 }} aria-label="payment memo table">
        <TableHead sx={{ backgroundColor: "rgba(52, 73, 94, 0.94)", color: "#fff" }}>
          <TableRow sx={{ backgroundColor: "rgba(52, 73, 94, 0.94)", color: "#fff" }}>
            <TableCell sx={{ color: "#fff" }}>
              <b>Print Memo</b>
            </TableCell>
            <TableCell sx={{ color: "#fff" }}>
              <b>Challan No.</b>
            </TableCell>
            <TableCell sx={{ color: "#fff" }}>
              <b>Date</b>
            </TableCell>
            <TableCell sx={{ color: "#fff" }}>
              <b>Total Amount (in Rs.)</b>
            </TableCell>
            <TableCell sx={{ color: "#fff" }}>
              <b>Print Receipt</b>
            </TableCell>
            {/* <TableCell sx={{ color: "#fff" }}>
              <b>Action</b>
            </TableCell> */}
          </TableRow>
        </TableHead>

        <TableBody>
          {taxHeadEstimates.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <IconButton>
                  <PaymentChallanPopup formData={formData} item={item} taxHead={taxHead} totalAmount={totalAmount} />
                </IconButton>
              </TableCell>
              <TableCell>{item.challanNo || "N/A"}</TableCell>
              <TableCell>
                {item.challanGeneratedDateTime
                  ? (() => {
                      const [datePart] = item.challanGeneratedDateTime.split(" ");
                      const [yyyy, mm, dd] = datePart.split("-");
                      return `${dd}-${mm}-${yyyy}`;
                    })()
                  : "N/A"}
              </TableCell>
              <TableCell>{item.estimateAmount || "N/A"}</TableCell>
              <TableCell>
                {item?.paymentStatus === "SUCCESS" ? (
                  <button
                    className="btn btn-primary"
                    style={{ padding: "5px", backgroundColor: "#1F4A7C" }}
                    onClick={() => {
                      setShowPaymentDetails(true);
                      setSelectedChallanNo(item.challanNo);
                    }}
                  >
                    Receipt
                  </button>
                ) : (
                  <h4>Not Done</h4>
                )}
                {showPaymentDetails && selectedChallanNo === item.challanNo && (
                  <DialogContentModal
                    title={"Application Payment Details"}
                    dataOpen={showPaymentDetails}
                    onClose={() => setShowPaymentDetails(false)}
                  >
                    <PaymentPrint id={formData?.applicationNo} formData={formData} />
                  </DialogContentModal>
                )}
              </TableCell>
              {/* <TableCell>
                <IconButton
                  color="error"
                  aria-label="Delete"
                  onClick={() => handleDelete(formData?.applicationNo, item?.challanNo, index, item?.estimateAmount)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ViewCompletionChallan;
